/**
 * Плавающий дисклеймер (разводящая, заказчик 23.10.2026): надпись лежит в
 * шапке подвала, но пока подвал не доскроллен — держится у низа окна
 * (класс is-floating: fixed, белая полупрозрачная плашка). Как только её
 * место в подвале целиком входит в окно — встаёт туда статично, с полями
 * макета (2613:12941). То же поведение, что у дисклеймера боевого сайта.
 *
 * Разметка: <div class="footer-disclaimer js-disclaimer-float"> внутри
 * <footer>. Место в подвале на время плавания держит padding-top подвала
 * (высота надписи) — без него подвал укорачивается и страница дёргается.
 *
 * Подгон кегля — regulatoryDisclaimer.js; ширина контейнера в обоих
 * состояниях одна (100 %), пересчёт не нужен.
 */
itsoftApp.createModule("disclaimerFloat", ["pageLoad", "windowScroll", "windowResize"], function () {
    const module = this;

    const FLOATING_CLASS = "is-floating";

    const DisclaimerFloat = function (el) {
        this.el = el;
        this.footer = el.closest("footer");
        this.floating = null;

        if (!this.footer) {
            return;
        }

        this.init();
    };

    /* Высота надписи в подвале (с полями макета) — её и резервируем; плавающая
       ниже (поля 16), мерить её нельзя: место в подвале прыгало бы при смене */
    DisclaimerFloat.prototype.measure = function () {
        const wasFloating = this.el.classList.contains(FLOATING_CLASS);

        if (wasFloating) {
            this.el.classList.remove(FLOATING_CLASS);
        }
        this.dockHeight = this.el.offsetHeight;

        if (wasFloating) {
            this.el.classList.add(FLOATING_CLASS);
        }
    };

    DisclaimerFloat.prototype.update = function () {
        /* Верх подвала в окне; при плавании место надписи держит padding-top */
        const dockTop = this.footer.getBoundingClientRect().top;
        const floating = dockTop + this.dockHeight > window.innerHeight;

        if (floating === this.floating) {
            return;
        }
        this.floating = floating;

        this.footer.style.paddingTop = floating ? this.dockHeight + "px" : "";
        this.el.classList.toggle(FLOATING_CLASS, floating);
        this.placeAbove();
    };

    /* Элементы, которые стоят над дисклеймером у низа окна (cookie-плашка
       Bitrix `.disc-cookie` — атрибут data-above-disclaimer): bottom = высота
       плавающей надписи, у подвала — 0 */
    DisclaimerFloat.prototype.placeAbove = function () {
        const self = this;
        const items = document.querySelectorAll("[data-above-disclaimer]");

        Array.prototype.forEach.call(items, function (item) {
            item.style.bottom = self.floating ? self.el.offsetHeight + "px" : "0px";
        });
    };

    DisclaimerFloat.prototype.init = function () {
        const self = this;

        this.measure();
        this.update();

        itsoftApp.modules.windowScroll.addEvent(function () {
            self.update();
        });

        itsoftApp.modules.windowResize.addEvent(function () {
            /* Кегль пересчитан (regulatoryDisclaimer) — высота другая */
            self.measure();
            self.floating = null;
            self.update();
        });

        /* Подгон кегля (regulatoryDisclaimer) меняет высоту надписи — мерим заново */
        this.el.addEventListener("disclaimer:fit", function () {
            self.measure();
            self.floating = null;
            self.update();
            self.placeAbove();
        });
    };

    const items = document.querySelectorAll(".js-disclaimer-float");

    if (!items.length) {
        return false;
    }

    Array.prototype.forEach.call(items, function (el) {
        el.disclaimerFloat = new DisclaimerFloat(el);
    });

    module.callback = DisclaimerFloat;
});
